export default function getCordovaWrapperVersion() {
		var name = "cordova"
		var url = window.location
    
		if (!url) url = location.href
		name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
		var regexS = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(regexS);
		var results = regex.exec(url);
		return results == null ? null : results[1];
  }